function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgMccServices = function SvgMccServices(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 40 40"
  }, props), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    d: "M26 5a1 1 0 0 0-1-1H15a1 1 0 0 0-1 1v2a1 1 0 0 0 1 1h2a1 1 0 0 1 1 1v3.082C10.051 12.736 2.63 17.276 2.038 25 1.996 25.55 2.448 26 3 26h34c.552 0 1.004-.45.962-1C37.371 17.275 29.95 12.735 22 12.081V9a1 1 0 0 1 1-1h2a1 1 0 0 0 1-1V5ZM2.694 30a2 2 0 0 0-1.973 1.671l-.333 2A2 2 0 0 0 2.361 36h35.278a2 2 0 0 0 1.973-2.329l-.334-2A2 2 0 0 0 37.306 30H2.694Z",
    clipRule: "evenodd",
    style: {
      fillRule: "evenodd",
      clipRule: "evenodd"
    }
  }));
};
export default SvgMccServices;